import styled from 'styled-components';

export const ThirdHeading = styled.h3`
  font-size: 24px;
`;
